const Success = {
  success: {
    main: '#36B37E',
    light: '#BBF2D3',
    dark: '#112A1F',
    '10': '#112A1F',
    '20': '#005237',
    '30': '#006644',
    '40': '#00875A',
    '50': '#36B37E',
    '60': '#7CD5A7',
    '70': '#98EEC3',
    '80': '#BBF2D3',
    '90': '#D4F9E4',
    '95': '#E8FBF0',
    '100': '#F3FFF8',
  },
};

export default Success;
